var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-container",
    [
      _c(
        "el-header",
        { staticClass: "nav-container" },
        [
          _c("navbar", {
            attrs: { "nav-index": "/crm" },
            on: { "nav-items-click": _vm.navClick },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c(
            "sidebar",
            {
              attrs: {
                items: _vm.crmRouters,
                "add-offset": _vm.quickAddOffset,
                "create-button-title": "快速创建",
                "main-router": "crm",
              },
              on: { select: _vm.handleSelect },
            },
            [
              _c(
                "div",
                {
                  staticClass: "quick-add",
                  attrs: { slot: "add" },
                  slot: "add",
                },
                [
                  _c(
                    "div",
                    { staticClass: "quick-add-content" },
                    _vm._l(_vm.quickAddList, function (item, index) {
                      return _c(
                        "p",
                        {
                          key: index,
                          on: {
                            click: function ($event) {
                              return _vm.addSkip(item)
                            },
                          },
                        },
                        [
                          _c("i", { class: ["wk", "wk-" + item.icon] }),
                          _c("span", [_vm._v(_vm._s(item.label))]),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-main",
            {
              staticStyle: { padding: "0" },
              attrs: { id: "crm-main-container" },
            },
            [_c("app-main")],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isCreate
        ? _c("c-r-m-all-create", {
            attrs: { "crm-type": _vm.createCRMType, action: _vm.createAction },
            on: {
              "save-success": _vm.createSaveSuccess,
              close: function ($event) {
                _vm.isCreate = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }